var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-reset-new-password-pane"},[_c('password-reset-new-password-section',{ref:"passwordResetNewPasswordSection",on:{"buttonDisabled":_vm.changeButtonDisabledStatus,"reset":_vm.reset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }